module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-bldg-41eff399bf16c6b244a33b8193906df5.png";